"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatekeeperRoutes = exports.GatekeeperRoute = void 0;
var react_1 = __importDefault(require("react"));
var Gatekeeper_1 = __importStar(require("./Gatekeeper"));
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var GatekeeperApiService_1 = __importDefault(require("./GatekeeperApiService"));
var Environment_1 = require("@CommonFrontendBackend/Environment");
var GatekeeperTelemetry_1 = require("./GatekeeperTelemetry");
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var inversify_1 = require("inversify");
require("Gatekeeper/Gatekeeper.ng.html");
var templateUrl = "Gatekeeper/Gatekeeper.ng.html";
var GatekeeperRoute;
(function (GatekeeperRoute) {
    GatekeeperRoute["Signup"] = "/signup";
    GatekeeperRoute["LoginOnly"] = "/loginOnly";
    GatekeeperRoute["Login"] = "/login";
    GatekeeperRoute["StanfordLogin"] = "/login/stanford";
    GatekeeperRoute["ResetPassword"] = "/login/reset-password";
    GatekeeperRoute["SetNewPassword"] = "/login/new-password";
})(GatekeeperRoute = exports.GatekeeperRoute || (exports.GatekeeperRoute = {}));
exports.GatekeeperRoutes = Object.values(GatekeeperRoute);
var showGatekeeper = function ($scope, createUi, page) {
    var publicApiBaseUrl = QwilrConfig.publicApiBaseUrl, environment = QwilrConfig.environment, fingerprintPublicKey = QwilrConfig.fingerprintPublicKey;
    var allowDevAutocomplete = (0, Environment_1.isNonProductionEnvironment)(environment || Environment_1.Environment.Production);
    var gatekeeperApiService = (0, GatekeeperApiService_1.default)(publicApiBaseUrl);
    gatekeeperApiService.trackGatekeeperPageOpened();
    var gatekeeperTelemetry = new GatekeeperTelemetry_1.GatekeeperTelemetry(fingerprintPublicKey);
    $scope.ui = {
        gatekeeper: (0, MountReactComponent_1.default)(createUi)(react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container();
                container.bind(GatekeeperTelemetry_1.GatekeeperTelemetry).toConstantValue(gatekeeperTelemetry);
                return container;
            } },
            react_1.default.createElement(Gatekeeper_1.default, { page: page, gatekeeperApiService: gatekeeperApiService, allowDevAutocomplete: allowDevAutocomplete }))),
    };
};
exports.default = angular.module("qwilr.gatekeeper", ["ui.router"]).config(function ($stateProvider) {
    $stateProvider
        .state(Gatekeeper_1.GatekeeperPage.Signup, {
        url: GatekeeperRoute.Signup,
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.Signup);
        },
    })
        .state(Gatekeeper_1.GatekeeperPage.LoginOnly, {
        url: GatekeeperRoute.LoginOnly,
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.LoginOnly);
        },
    })
        .state(Gatekeeper_1.GatekeeperPage.Login, {
        url: GatekeeperRoute.Login,
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.Login);
        },
    })
        .state(Gatekeeper_1.GatekeeperPage.StanfordLogin, {
        url: GatekeeperRoute.StanfordLogin,
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.StanfordLogin);
        },
    })
        .state(Gatekeeper_1.GatekeeperPage.ResetPassword, {
        url: GatekeeperRoute.ResetPassword,
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.ResetPassword);
        },
    })
        .state(Gatekeeper_1.GatekeeperPage.SetNewPassword, {
        url: GatekeeperRoute.SetNewPassword,
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.SetNewPassword);
        },
    })
        .state("".concat(Gatekeeper_1.GatekeeperPage.SetNewPassword, "1"), {
        url: "".concat(GatekeeperRoute.SetNewPassword, "/"),
        templateUrl: templateUrl,
        controller: function ($scope, createUi) {
            showGatekeeper($scope, createUi, Gatekeeper_1.GatekeeperPage.SetNewPassword);
        },
    });
});
